export default __webpack_public_path__ + "static/media/item1.d00e43d4.png";